/**
 * A synchronous in-flight latch.
 *
 * React state (`formState.isSubmitting`) cannot guard against a double-click:
 * two clicks in the same tick both run before React re-renders the button to
 * disabled, so both pass the check. A closure variable mutates immediately, so
 * the second caller sees the latch already held.
 */
export interface SubmitGuard {
  /** Latches and returns true when free; returns false when already held. */
  tryAcquire(): boolean;
  /** Unlatches. Safe to call when not held. */
  release(): void;
  readonly isHeld: boolean;
}

export function createSubmitGuard(): SubmitGuard {
  let held = false;

  return {
    tryAcquire(): boolean {
      if (held) {
        return false;
      }
      held = true;
      return true;
    },
    release(): void {
      held = false;
    },
    get isHeld(): boolean {
      return held;
    },
  };
}
